import { useEffect, useState } from "react";

const getFaceBookUrl = (url, text) => {
  return `https://www.facebook.com/sharer.php?u=${url}&quote=${text || ""}`;
};

const getTwitterUrl = (url, text) => {
  // return `https://twitter.com/share?url=${url}&text=${text || ""}`;
  return `https://twitter.com/intent/tweet?text=${text}`;
};

const getLinkedInUrl = (url, text) => {
  return `https://www.linkedin.com/sharing/share-offsite/?url=https://shptchallenges.com/test-yourself#/`;
};

const getUrls = (url, text) => {
  return {
    facebook: getFaceBookUrl(url, text),
    twitter: getTwitterUrl(url, text),
    linkedIn: getLinkedInUrl(url, text),
  };
};

export default function useSocialShare({ url, text }) {
  const [urls, setUrls] = useState(getUrls(url, text));

  useEffect(() => {
    setUrls(getUrls(url, text));
  }, [url, text]);

  return urls;
}
